import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppSettings } from '../../config/config';
import { FormValidator } from '../form.validator';
import { GroupService } from '../groups/groups.service';
import { TransportService } from '../transport/transport.service';
import { EditStudentPopupService } from "./edit-student-popup.service"
import * as registrationStrings from "../stringFiles/registration.json";
import moment from 'moment';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { commonFunctionService } from '../utils/commonFunctions';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var customToastr: any;
@Component({
  selector: 'app-edit-student-popup',
  templateUrl: './edit-student-popup.component.html',
  styleUrl: './edit-student-popup.component.css',
  providers: [GroupService, FormValidator, TransportService]
})

export class EditStudentPopupComponent implements OnInit {
  @Input() visible: string;
  @Input() currType: string;
  @Input() studentName: string;
  @Input() studentId: number;
  @Input() academicId: number;
  @Input() academicYear: string;
  @Input() button_text: string;
  @Output() save_button_event: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();
  @ViewChild('editFessFatherMobileNumber', {static:false }) fatherContactNumberInputRef !:ElementRef;
  @ViewChild('editMotherMobileNumber', {static:false }) motherContactNumberInputRef !:ElementRef;
  @ViewChild('editStudentContactNumber', {static:false }) studentContactNumberInputRef !:ElementRef;
  @ViewChild('editGuardianMobileNumber', {static:false }) guardianMobileNumberInputRef !:ElementRef;
  
  strings: any;
  brand = this.brandService.brand;
  constructor(
    private formValidator: FormValidator, private groupservice: GroupService,
    private transportservice: TransportService,
    private editStudentPopupService: EditStudentPopupService,
    private commonFunction: commonFunctionService, private translate : TranslateService,
    private brandService: BrandService
  ) {
    this.strings = registrationStrings;
  }

  ngOnInit() {
    this.editStudentFormData.student.gender = 1;
    this.viewStudentTerms = [];
    this.viewStudentTermIds = [];
    this.studentSelectedTerms = [];
    this.getAuthToken = localStorage.getItem('usertoken');
    this.getStudentDetails();
    this.getStudentTermsDetails();
    this.getSchoolHouseListDetails();
    if (this.editStudentFormData.student.isBlocked === 1) {
      this.isDeactivated = true;
    } else if (this.editStudentFormData.student.isBlocked === 0) {
      this.isDeactivated = false;
    }
  }

  editStudentLoadStatus = false;
  loaderEditStudent = false;
  admissionObj = null;
  getAuthToken: any
  updateStudentClassChangeError = { oldClassName: '', structureName: '', newClassName: '', paidAmount: '', feeStrutureId: null };
  houseNameList = [];
  studentSelectedTerms = [];
  busStopListData = [];
  private URL = AppSettings.API_ENDPOINT;
  mCallback = null;
  nStudentSelectedTerms = [];
  isDeactivated = false;
  selectedReason: any;
  selectAllTerms: boolean = false;
  showBusTermLayout: boolean = true;
  selectedHouseName: string;
  debounceTimer: any;
  casteCertificateFileType: string = ""
  speciallyAbledFileType: string = ""
  ewsCertificateFileType: string = ""
  singleGirlChildCertificateFileType: string = ""
  tcOrBirthCertificateFileType: string = ""
  aadharReferenceFileType: string = ""

// Contact number variables
  editSelectedStudentContact = '';
  editSelectedFatherContact = '';
  editSelectedMotherContact = '';
  editSelectedGuardianContact = ''; 
  invalidStudentContactNumber = false;
  invalidFatherContactNumber = false;
  invalidMotherContactNumber = false;
  invalidGuardianContactNumber = false;
  moment = moment;

  editStudentFormData = {
    categories: [], classStandards: [], sections: [],
    student: {
      houseName: null,
      categoryId: null,
      aadharCopy: null,
      aadharNumber: '',
      studentImage: 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png',
      fkClassStandardsId: null,
      classId: '0',
      dateOfAdmission: '',
      dateOfBirth: '',
      countryCode: this.brand.defaultCountryDialCode || '91',
      motherCountryCode: this.brand.defaultCountryDialCode || '91',
      guardianCountryCode: this.brand.defaultCountryDialCode || '91',
      studentCountryCode: this.brand.defaultCountryDialCode || '91',
      studentName: '',
      surname: '',
      studentEmail: '',
      studentPhone: '',
      registrationId: '',
      gender: 0,
      rollNumber: '',
      isAppUser: 0,
      isBlocked: 0,
      parentName: '',
      mobileNumber: '',
      fatherOccupation: '',
      fatherQualification: '',
      address: '',
      motherName: '',
      motherPhone: '',
      motherOccupation: '',
      motherQualification: '',
      motherAddress: '',
      stopId: null,
      studentId: null,
      busId: null,
      guardianName: '',
      guardianPhone: '',
      guardianOccupation: '',
      guardianQualification: '',
      guardianAddress: '',
      penNumber: "",
      fatherPinCode: "",
      isEWSCategory: null,
      isMinority: null,
      isSingleGirlChild: null,
      isSpeciallyAbled: null,
      singleGirlChildCertificate: null,
      speciallyAbledCertificate: null,
      tcOrBirthCertificate: null,
      casteCertificate: null,
      ewsCertificate: null,
      motherAnnualIncome: null,
      fatherAnnualIncome: null,
      cast: "",
      motherPinCode: "",
      guardianAnnualIncome: null,
      guardianPinCode: "",
      initialClassId :"",
      emailId: null,
      motherEmail: null
    },
    deactivateReasons: []
  };
  busListDataEditStudent = [];
  selectedStudentGender: boolean;
  viewStudentTerms = [];
  viewStudentTermIds = [];
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  selectStopFare = 0;
  selectedStopId = null;
  selectedBusId = null;
  busListData = [];
  _studentSelectedTerms = [];
  oldButtonText;
  isLoading: boolean;
  showProgress: boolean = false;
  showProgressForAadhar: boolean = false;
  profileImageSelected: boolean = false;
  loader: boolean = false;
  showClassChangeWarning: boolean = false;
  schoolCurrency = localStorage.getItem('currency');
  initialClassStandardId: number;
  initialClassCategoryId: number;
  initialCategoryList: any = [];
  initialClassStandardsList: any = [];
  initialSectionList: any = [];
  handleKeyDown(event:KeyboardEvent) {
    this.commonFunction.handleKeyDown(event);
  }

  showProgressForTcOrBirth: boolean = false;
  showProgressForSpeciallyAbled: boolean = false;
  showProgressForEWS: boolean = false;
  showProgressForSingleGirlChild: boolean = false;
  showProgressForCaste: boolean = false;
  
  getSchoolHouseListDetails() {
    this.groupservice.getSchoolHouseList(localStorage.getItem('usertoken')).subscribe(
      (data: any) => {
        if (data.status) {
          this.houseNameList = JSON.parse(JSON.stringify(data.list));
        }
        else {
          this.houseNameList = [];
        }
      },
      error => {
        console.error(error)
      }
    );
  }

  isCurrentAcademicToOpenStudentForm = false;

  openEditStudentFrom(studentId, callback, isCurrentAcademic) {
    this.getAuthToken = localStorage.getItem('usertoken');
    this.isCurrentAcademicToOpenStudentForm = isCurrentAcademic;
    this.mCallback = callback;
    // this.clearEditStudentForm();
    this.getSchoolHouseListDetails();
    this.loaderEditStudent = false;
  }

  close() {
    this.visible = 'none';
    this.closePopup.emit();
    this.showClassChangeWarning = false;
  }
  closeFeesNotification() {
    this.showClassChangeWarning = false;
    this.editStudentFormData.classStandards =  this.initialClassStandardsList 
    this.editStudentFormData.sections =this.initialSectionList 
    this.editStudentFormData.student.fkClassStandardsId = this.initialClassStandardId  
    this.editStudentFormData.student.categoryId = this.initialClassCategoryId;
    this.editStudentFormData.student.classId = this.editStudentFormData.student.initialClassId;
  }

  // on changing the date in dob
  onDateChange(selectedDate) {
    this.editStudentFormData.student.dateOfBirth = this.formatDOBForDisplay(selectedDate);
  }

  // open calendar on click input box
  openCalendar(){
    const input = document.getElementById('edit-student-dob') as HTMLInputElement;
    if (input) {
      input.showPicker();  
    }
  }

  getStudentDetails() {
    this.groupservice.getStudentDetailsForEditForm(this.studentId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.editStudentFormData = JSON.parse(JSON.stringify(data));
          this.appendDeactivateStudentReasons(this.editStudentFormData.deactivateReasons);
          this.editStudentFormData.student.dateOfBirth = this.editStudentFormData.student.dateOfBirth;
          this.editSelectedFatherContact = this.editStudentFormData.student.mobileNumber;
          this.editSelectedMotherContact = this.editStudentFormData.student.motherPhone;
          this.editSelectedGuardianContact = this.editStudentFormData.student.guardianPhone;
          this.editSelectedStudentContact = this.editStudentFormData.student.studentPhone;
          this.editStudentFormData.student.countryCode = this.editStudentFormData.student.countryCode || this.brand.defaultCountryDialCode || '91';
          this.editStudentFormData.student.motherCountryCode = this.editStudentFormData.student.motherCountryCode || this.brand.defaultCountryDialCode || '91';
          this.editStudentFormData.student.studentCountryCode = this.editStudentFormData.student.studentCountryCode || this.brand.defaultCountryDialCode || '91';
          this.editStudentFormData.student.guardianCountryCode = this.editStudentFormData.student.guardianCountryCode || this.brand.defaultCountryDialCode || '91';
          this.editStudentFormData.student.initialClassId = this.editStudentFormData.student.classId;
          this.initialCategoryList = data.categories;
          this.initialClassStandardsList = this.editStudentFormData.classStandards;
          this.initialSectionList = this.editStudentFormData.sections;
          this.initialClassStandardId = this.editStudentFormData.student.fkClassStandardsId;
          this.initialClassCategoryId = this.editStudentFormData.student.categoryId;
          const countryData = this.getIntlTelInputGlobals().getCountryData();          
          const matchedCountry = countryData.find((country: any) => {
            return `${country.dialCode}` == this.editStudentFormData.student.countryCode;
          });

          const matchedCountryForMother = countryData.find((country: any)=>{
            return `${country.dialCode}` == this.editStudentFormData.student.motherCountryCode;
          })

          const matchedCountryForGuardian = countryData.find((country: any)=>{
            return `${country.dialCode}` == this.editStudentFormData.student.guardianCountryCode;
          })

          const matchedCountryForStudent = countryData.find((country: any)=>{
            return `${country.dialCode}` == this.editStudentFormData.student.studentCountryCode;
          })

          const mobileNumberForEditStudent = $('#edit-fees-student-number');
          mobileNumberForEditStudent.val('');
          mobileNumberForEditStudent.intlTelInput({
            initialCountry: matchedCountryForStudent.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay:false,
            utilsScript:
              'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js'
          });

          const fatherMobileNumberInput = $('#edit-fees-student-father-mobile-number');
          fatherMobileNumberInput.val('');
          fatherMobileNumberInput.intlTelInput({
            initialCountry: matchedCountry.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay:false,
            utilsScript:
              'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
          });

          const motherMobileNumberInput = $("#edit-fees-student-mother-mobile-number")
          motherMobileNumberInput.val('');
          motherMobileNumberInput.intlTelInput({
            initialCountry: matchedCountryForMother.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay:false,
            utilsScript:
              'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
          });

          const guardianMobileNumberInput = $("#edit-fees-student-guardian-mobile-number")
          guardianMobileNumberInput.val('');
          guardianMobileNumberInput.intlTelInput({
            initialCountry: matchedCountryForGuardian.iso2,
            separateDialCode: false,
            autoPlaceholder: 'off',
            autoFormat: false,
            nationalMode: false,
            formatOnDisplay:false,
            utilsScript:
              'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
          });

          mobileNumberForEditStudent.on('countrychange', () => {
            mobileNumberForEditStudent.val('');
            const countryData = mobileNumberForEditStudent.intlTelInput('getSelectedCountryData');
            this.editStudentFormData.student.studentCountryCode = countryData.dialCode;
          });

          fatherMobileNumberInput.on('countrychange', () => {
            fatherMobileNumberInput.val('');
            const countryData = fatherMobileNumberInput.intlTelInput('getSelectedCountryData');
            this.editStudentFormData.student.countryCode = countryData.dialCode;
          });

          motherMobileNumberInput.on('countrychange', () => {
            motherMobileNumberInput.val('');
            const countryData = motherMobileNumberInput.intlTelInput('getSelectedCountryData');
            this.editStudentFormData.student.motherCountryCode = countryData.dialCode
          });

          guardianMobileNumberInput.on('countrychange', () => {
            guardianMobileNumberInput.val('');
            const countryData = guardianMobileNumberInput.intlTelInput('getSelectedCountryData');
            this.editStudentFormData.student.guardianCountryCode = countryData.dialCode;
          });

          this.selectedHouseName = this.editStudentFormData.student.houseName

          this.editStudentFormData.student.isMinority = this.editStudentFormData.student.isMinority == 1 ? true : false

          this.editStudentFormData.student.isSpeciallyAbled = this.editStudentFormData.student.isSpeciallyAbled == 1 ? true : false

          this.editStudentFormData.student.isEWSCategory = this.editStudentFormData.student.isEWSCategory == 1 ? true : false

          this.editStudentFormData.student.isSingleGirlChild = this.editStudentFormData.student.isSingleGirlChild == 1 ? true : false

          this.appendDeactivateStudentReasons(this.editStudentFormData.deactivateReasons);

          if (this.editStudentFormData.student.casteCertificate) {
            this.casteCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.editStudentFormData.student.casteCertificate);
          }

          if (this.editStudentFormData.student.aadharCopy) {
            this.aadharReferenceFileType = this.commonFunction.getFileTypeFromUrl(this.editStudentFormData.student.aadharCopy);
          }

          if (this.editStudentFormData.student.tcOrBirthCertificate) {
            this.tcOrBirthCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.editStudentFormData.student.tcOrBirthCertificate);
          }

          if (this.editStudentFormData.student.ewsCertificate) {
            this.ewsCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.editStudentFormData.student.ewsCertificate);
          }

          if (this.editStudentFormData.student.speciallyAbledCertificate) {
            this.speciallyAbledFileType = this.commonFunction.getFileTypeFromUrl(this.editStudentFormData.student.speciallyAbledCertificate);
          }

          if (this.editStudentFormData.student.singleGirlChildCertificate) {
            this.singleGirlChildCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.editStudentFormData.student.singleGirlChildCertificate);
          }

          this.editStudentFormData.student.dateOfBirth = this.formatDOBForDisplay(this.editStudentFormData.student.dateOfBirth);
        },
        error => {
          this.editStudentFormData = {
            categories: [], classStandards: [], sections: [],
            student: {
              houseName: null,
              categoryId: null,
              aadharCopy: null,
              aadharNumber: '',
              studentImage: 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png',
              fkClassStandardsId: null,
              classId: '0',
              dateOfAdmission: '',
              dateOfBirth: '',
              countryCode: this.brand.defaultCountryDialCode || '91',
              motherCountryCode: this.brand.defaultCountryDialCode || '91',
              guardianCountryCode: this.brand.defaultCountryDialCode || '91',
              studentCountryCode: this.brand.defaultCountryDialCode || '91',
              studentName: '',
              surname: '',
              studentEmail: '',
              studentPhone: '',
              registrationId: '',
              gender: 0,
              rollNumber: '',
              isAppUser: 0,
              isBlocked: 0,
              parentName: '',
              mobileNumber: '',
              fatherOccupation: '',
              fatherQualification: '',
              address: '',
              motherName: '',
              motherPhone: '',
              motherOccupation: '',
              motherQualification: '',
              motherAddress: '',
              stopId: null,
              studentId: null,
              busId: null,
              guardianName: '',
              guardianPhone: '',
              guardianOccupation: '',
              guardianQualification: '',
              guardianAddress: '',
              penNumber: "",
              fatherPinCode: "",
              isEWSCategory: null,
              isMinority: null,
              isSingleGirlChild: null,
              isSpeciallyAbled: null,
              singleGirlChildCertificate: null,
              speciallyAbledCertificate: null,
              tcOrBirthCertificate: null,
              casteCertificate: null,
              ewsCertificate: null,
              motherAnnualIncome: null,
              fatherAnnualIncome: null,
              cast: "",
              motherPinCode: "",
              guardianAnnualIncome: null,
              guardianPinCode: "",
              initialClassId:"",
              emailId: null,
              motherEmail: null
            },
            deactivateReasons: []
          };
        }
      );
  }

  getIntlTelInputGlobals(): any {
    return (window as any).intlTelInputGlobals;
  }

  onChangeEditStudentCategory(categoryId: string) {
    this.groupservice.getClassStandardsByCategoryV2(categoryId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.editStudentFormData.classStandards = data;
          this.editStudentFormData.classStandards = data;
          this.editStudentFormData.sections = [];
          this.editStudentFormData.student.fkClassStandardsId = null;
          this.editStudentFormData.student.classId = null;
        },
        error => {
          this.editStudentFormData.classStandards = [];
          this.editStudentFormData.sections = [];
        }
      );
  }

  appendDeactivateStudentReasons(reasons) {
    this.isDeactivated = false;
    this.editStudentFormData.deactivateReasons = reasons;
  }
  onChangeEditStudentClass(classStandardId: string) {
    this.groupservice.getClassSectionsByClassIdFunV2(classStandardId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.editStudentFormData.sections = data;
          this.editStudentFormData.student.classId = null;
        },
        error => {
          this.editStudentFormData.sections = [];
        }
      );
  }

  onChangeEditStudentSection(sectionId: string) {
    // This to check where the student have same fee structure or different 
    // If student have paid the fee & trying move another class which fee structure is different it show popup
    // don't remove or modify without confirming from @Anooj Krishnan
    this.admissionObj = {
      oldClassId : ''
    }
    if (this.editStudentFormData.student.classId !== this.editStudentFormData.student.initialClassId) {
      this.loaderEditStudent = true;
      this.groupservice.studentClassChangeValidation(this.editStudentFormData.student.classId,this.editStudentFormData.student.initialClassId,
      this.editStudentFormData.student.studentId, this.getAuthToken)
        .subscribe(
          (data: any) => {
            if (data.allowUpdate === 'NO') {
              this.editStudentLoadStatus = false;
              this.updateStudentClassChangeError = data;
              this.showClassChangeWarning = true;
            } 
            else {
              this.showClassChangeWarning = false;
              this.admissionObj.oldClassId = this.editStudentFormData.student.initialClassId || null;
            }
          },
          async error => {
            this.loaderEditStudent = false;
            const studentDetailsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('studentDetailsNotUpdatedPleaseTryAgain'))
            customToastr(studentDetailsNotUpdatedPleaseTryAgainTranslation, 'error');
          }
        );
      this.editStudentLoadStatus = false;
    } 
  }

  clickedOnEditStudentUpdatePic() {
    const fileInput = document.getElementById('edit-student-image-header-input') as HTMLInputElement;
    fileInput.click();
  }

  async onEditStudentImageChange(event: Event) {
    this.showProgress = false;
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();
      const validExtensions = ['gif', 'jpeg', 'png', 'jpg', 'pdf'];

      if (!extension || validExtensions.indexOf(extension) === -1) {
        this.profileImageSelected = false;
        fileInput.value = '';
        this.showProgress = false;
        const pleaseSelectAValidImageTypeOfGifJpegPngJpgPdfTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfGifJpegPngJpgPdf')); 
        customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgPdfTranslation, 'error');
      } else if (file.size > (1024 * 1024 * 20)) {
        this.profileImageSelected = false;
        fileInput.value = '';
        this.showProgress = false;
        const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
        customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
      } else {
        this.profileImageSelected = true;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.editStudentFormData.student.studentImage = e.target.result;
        };
        reader.readAsDataURL(file);
        this.uploadEditStudentImage(file);
      }
    }
  }

  uploadEditStudentImage(file: File) {
    const authToken = localStorage.getItem('usertoken');
    const studentId = this.studentId.toString()
    const formData = new FormData();
    formData.append('image', file);
    this.showProgress = true;
    this.editStudentPopupService.uploadEditStudentImageApi(studentId, authToken, formData)
      .subscribe(
        async (data: any) => {
          this.showProgress = false;
          if (data && data.status) {
            if (data.body && data.body.processedImageUrl[0]) {
              this.editStudentFormData.student.studentImage = data.body.processedImageUrl[0]
            }
            const studentProfileImageUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentProfileImageUpdatedSuccessfully')); 
            customToastr(studentProfileImageUpdatedSuccessfullyTranslation, 'success');
          } else {
            const profileImageNotUpdatedTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdated')); 
            customToastr(profileImageNotUpdatedTranslation, 'error');
          }
          this.profileImageSelected = false;
        },
        async error => {
          this.showProgress = false;
          const profileImageNotUpdatedServerNotReachableTranslation = await firstValueFrom(this.translate.get('profileImageNotUpdatedServerNotReachable')); 
          customToastr(profileImageNotUpdatedServerNotReachableTranslation, 'error');
          this.profileImageSelected = false;
        }
      );

  }

  openEditStudentAadharCopyUpload() {
    document.getElementById('edit-student-aadhar-copy')?.click();
  }

  startUploadingEditStudentAadharCopy(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.aadharReferenceFileType = file.type;
      if (this.validateImage('#edit-student-aadhar-copy', '#edit-student-aadhar-progressbar', '#edit-student-aadhar-image-ele')) {
        document.getElementById('edit-student-aadhar-copy-button')?.classList.add('hide');
        this.showProgressForAadhar = true;
        const authToken = localStorage.getItem('usertoken');
        const imageId = 'edit-student-aadhar-copy';
        const studentId = this.studentId.toString();
        const ImageUploadData = new FormData();
        ImageUploadData.append('aadharReference', (document.getElementById(imageId) as HTMLInputElement).files![0]);
        this.editStudentPopupService.uploadEditStudentImageApi(studentId, authToken, ImageUploadData)
          .subscribe(
            async (data: any) => {
              this.showProgressForAadhar = false;
              if (data.body && data.body.processedImageUrl[0]) {
                this.editStudentFormData.student.aadharCopy = data.body.processedImageUrl[0]
              }
              document.getElementById('edit-student-aadhar-copy-button')?.classList.remove('hide');
              const studentAadhaarCopyUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentAadhaarCopyUpdatedSuccessfully')); 
              customToastr(studentAadhaarCopyUpdatedSuccessfullyTranslation, 'success');
              this.profileImageSelected = false;
            },
            async error => {
              this.showProgressForAadhar = false;
              const aadhaarCopyNotUpdatedTranslation = await firstValueFrom(this.translate.get('aadhaarCopyNotUpdated')); 
              customToastr(aadhaarCopyNotUpdatedTranslation, 'error');
              this.profileImageSelected = false;
              const button = document.getElementById('edit-student-aadhar-copy-button');
              const imageElement = document.getElementById('edit-student-aadhar-image-ele') as HTMLImageElement;
              const inputElement = document.getElementById('edit-student-aadhar-copy') as HTMLInputElement;
              if (this.editStudentFormData.student.aadharCopy) {
                button!.textContent = 'Change';
                inputElement.value = '';
                imageElement.src = this.editStudentFormData.student.aadharCopy;
                imageElement.classList.remove('hide');
              } else {
                button!.textContent = 'Upload';
                inputElement.value = '';
                imageElement.src = '';
                imageElement.classList.add('hide');
              }
            }
          );
      }
    }

  }

  async validateImage(id: string, progressbarId: string, imageEleId: string): Promise<boolean> {
    const element = document.querySelector(id) as HTMLInputElement;
    const extension = element.value.split('.').pop()?.toLowerCase();
    const ExtListToUpload = ['gif', 'jpeg', 'png', 'jpg', 'pdf'];
    if (!ExtListToUpload.includes(extension!)) {
      element.value = '';
      document.querySelector(progressbarId)?.classList.add('hide');
      const pleaseSelectAValidImageTypeOfGifJpegPngJpgPdfTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfGifJpegPngJpgPdf')); 
      customToastr(pleaseSelectAValidImageTypeOfGifJpegPngJpgPdfTranslation, 'error');
      return false;
    }
    if (element.files![0].size > (1024 * 1024 * 20)) {
      element.value = '';
      document.querySelector(progressbarId)?.classList.add('hide');
      const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
      customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
      return false;
    } else {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imageElement = document.querySelector(imageEleId) as HTMLImageElement;
        imageElement.src = e.target.result;
        imageElement.classList.remove('hide');
      };
      reader.readAsDataURL(element.files![0]);
      return true;
    }
  }

  editStudentDeactiveStateChange() {
    const activeAcc = this.editStudentFormData.student.isBlocked === 0;
    const deActiveAcc = this.editStudentFormData.student.isBlocked === 1;
    this.isDeactivated = deActiveAcc;
  }

  editStudentAppendStopList() {
    this.isLoading = true;
    this.editStudentPopupService.fetchBusStop(localStorage.getItem('usertoken'), this.academicId)
      .subscribe(
        (data: any) => {
          this.isLoading = false;
          this.busStopListData = data;
          if (this.selectedStopId) {
            this.onChangeBusStopGetBusList(this.selectedStopId)
          }
        },
        error => {
          this.isLoading = false;
        }
      );
  }

  onChangeEditStudentStop(id) {
    this.onChangeBusStopGetBusList(id);
  }

  onChangeBusStopGetBusList(stopId) {
    this.isLoading = true;
    this.editStudentPopupService.getBusListForStop(stopId, localStorage.getItem('usertoken'), this.academicId)
      .subscribe(
        async (data: any) => {
          this.isLoading = false;
          this.busListData = data;
          if (this.busListData.length == 0) {
            const thereAreNoBusesPassingThroughTheStopTranslation = await firstValueFrom(this.translate.get('thereAreNoBusesPassingThroughTheStop')); 
            customToastr(thereAreNoBusesPassingThroughTheStopTranslation, 'error');
          }
          else {
            for (let i = 0; i < this.studentSelectedTerms.length; i++) {
              if (this.studentSelectedTerms[i].isEditable) {
                this.studentSelectedTerms[i].fkBusStopId = stopId;
              }
            }
          }
        },
        error => {
          this.isLoading = false;
          this.busListData = [];
        }
      );
  }

  getStudentTermsDetails() {
    this.isLoading = true;
    this.editStudentPopupService.getStudentTermsDetail(this.studentId, localStorage.getItem('usertoken'), this.academicId)
      .subscribe(
        (data: any) => {
          this.isLoading = false;
          if (data.success == true) {
            if (data.data.length > 0) {
              let busOptionExisting = data.data.filter(function (term) {
                return term.fkBusStopId ? true : false;
              });
              if (busOptionExisting && busOptionExisting.length > 0) {
                this.selectedStopId = busOptionExisting[0].fkBusStopId || null;
                this.selectedBusId = busOptionExisting[0].fkBusId || null;
              }
              else {
                this.selectedStopId = null;
                this.selectedBusId = null;
              }
            }
            var studentTerms = data.data;
            var sortedTerms = [];
            for (var i = (studentTerms.length - 1); i >= 0; i--) {
              sortedTerms.push(studentTerms[i]);
            }
            for (var i = 0; i < sortedTerms.length; i++) {
              if (sortedTerms[i].isSelectedTerm == undefined) {
                sortedTerms[i].isSelectedTerm = false;
              }
              else if (sortedTerms[i].isSelectedTerm) {
                this.viewStudentTerms.push(sortedTerms[i]);
                this.viewStudentTermIds.push(sortedTerms[i].pkBusStopTermId)
              }
              if (sortedTerms[i].isPaid == undefined) {
                sortedTerms[i].isPaid = false;
              }
              if (sortedTerms[i].isPaid) {
                sortedTerms[i].isEditable = false
              }
              else {
                sortedTerms[i].isEditable = true
              }
            }
            this.studentSelectedTerms = sortedTerms;
            this._studentSelectedTerms = sortedTerms;
            this.editStudentAppendStopList();
            this.changeAllSelectBoxVal();
          }
        },
        error => {
          this.isLoading = false;
        }
      );
  }

  onBusTermChanged(event, term) {
    let termId = term.pkBusStopTermId;
    let isChecked = event.currentTarget.checked;
    term.isSelectedTerm = isChecked;
    if (this.viewStudentTermIds.indexOf(termId) != -1 && isChecked == false) {
      let index = this.viewStudentTermIds.indexOf(termId);
      this.viewStudentTermIds.splice(index, 1);
    }
    else {
      this.viewStudentTermIds.push(termId)
    }
    this.changeAllSelectBoxVal();
  }

  onBusTermChangedSelectAll(event) {
    let isChecked = event.currentTarget.checked;
    for (let i = 0; i < this.studentSelectedTerms.length; i++) {
      if (isChecked == true) {
        this.studentSelectedTerms[i].isSelectedTerm = true;
        this.viewStudentTermIds.push(this.studentSelectedTerms[i].pkBusStopTermId);
      }
      else {
        if (!this.studentSelectedTerms[i].isEditable) {

        }
        else {
          this.studentSelectedTerms[i].isSelectedTerm = false;
          this.viewStudentTermIds.splice(i, 1);
        }
      }
    }
    this.changeAllSelectBoxVal();
  }

  changeAllSelectBoxVal() {
    this.selectAllTerms = this.viewStudentTermIds.length == this.studentSelectedTerms.length;
  }

  async editStudentClearTransportOptions() {
    let isOkayToClear = true;
    this.studentSelectedTerms.forEach(term => {
      if (!term.isEditable) {
        isOkayToClear = false;
      }
    });
    if (isOkayToClear) {
      this.studentSelectedTerms.forEach(term => {
        term.isSelectedTerm = false;
      });
      this.busStopListData = []
      this.selectAllTerms = false;
      this.showBusTermLayout = false;
      this.studentSelectedTerms = [];
    } else {
      const translation = await firstValueFrom(this.translate.get('notAllowedToClearTransport'));
      customToastr(translation, 'error');
    }
  }

  async onChangeFatherEmail() {
    if (this.formValidator.validateIsData(this.editStudentFormData.student.emailId) && !this.formValidator.validateIsEmail(this.editStudentFormData.student.emailId)) {
      $('#edit-father-email').addClass('validateErrorforAddStudent');
    } else {
      $('#edit-father-email').removeClass('validateErrorforAddStudent');
    }
  }

  async onChangeMotherEmail() {
    if (this.formValidator.validateIsData(this.editStudentFormData.student.motherEmail) && !this.formValidator.validateIsEmail(this.editStudentFormData.student.motherEmail)) {
      $('#edit-mother-email').addClass('validateErrorforAddStudent');
    } else {
      $('#edit-mother-email').removeClass('validateErrorforAddStudent');
    }
  }

  async updateSelectedStudentDetails() {
    this.editStudentLoadStatus = true;
    const busTerms = [];
    const sectionId = this.editStudentFormData.student.classId
    let studentGender;
    let studentBluewingsAppStatus;
    let studentAccountStatus;
    const reasonForDeactiveStudent = '';
    let deactivationReasonId = null;
    const accountStatusActive = $('#edit-student-accountStatusActive').prop('checked');
    const accountStatusDeactive = $('#edit-student-accountStatusDeActive').prop('checked');
    if (accountStatusDeactive) {
      deactivationReasonId = $('#edit-student-deactive-reason-select').val();
      studentAccountStatus = 1;
    } else {
      deactivationReasonId = null;
      studentAccountStatus = 0;
    }

    // gender
    if ($('#edit-student-genderMale').prop('checked')) {
      studentGender = 1;
    } else if ($('#edit-student-genderFemale').prop('checked')) {
      studentGender = 0;
    } else {
      studentGender = 1;
    }
    // appStatus
    if ($('#edit-student-appStatusConected').prop('checked')) {
      studentBluewingsAppStatus = 1;
    } else if ($('#edit-student-appStatusDisConneted').prop('checked') === true) {
      studentBluewingsAppStatus = 0;
    } else {
      studentBluewingsAppStatus = 0;
    }
    
    let editstudentName = this.editStudentFormData.student.studentName
    let editstudentSurname = this.editStudentFormData.student.surname
    let editstudentStudentEmail = this.editStudentFormData.student.studentEmail 
    let editStudentFatherEmail = this.editStudentFormData.student.emailId
    let editStudentMotherEmail = this.editStudentFormData.student.motherEmail
    let editStudentAdmissionnum = this.editStudentFormData.student.registrationId;
    let editstudentStudentDOB = this.editStudentFormData.student.dateOfBirth
    let editstudentStudentRollNumber = this.editStudentFormData.student.rollNumber
    const editstudentStudentAadharNumber = this.editStudentFormData.student.aadharNumber
    let editstudentFatherName = this.editStudentFormData.student.parentName
    let editstudentFatherQualifiation = this.editStudentFormData.student.fatherQualification
    let editstudentFatherAddress = this.editStudentFormData.student.address
    const editstudentFatherOccupation = this.editStudentFormData.student.fatherOccupation
    let houseName = this.selectedHouseName
    if (houseName === 'None' || houseName == null || houseName == 'null') {
      houseName = null;
    }
    const editstudentMotherName = this.editStudentFormData.student.motherName
    const editstudentMotherQualifiation = this.editStudentFormData.student.motherQualification
    const editstudentMotherAddress = this.editStudentFormData.student.motherAddress
    const editstudentMotherOccupation = this.editStudentFormData.student.motherOccupation
    const editstudentGuardianName = this.editStudentFormData.student.guardianName 
    const editstudentGuardianQualifiation = this.editStudentFormData.student.guardianQualification
    const editstudentGuardianAddress = this.editStudentFormData.student.guardianAddress
    const editstudentGuardianOccupation = this.editStudentFormData.student.guardianOccupation
    let isStudentDetailsValid = true;


    if (!this.formValidator.validateIsData(editstudentName) || $.isNumeric(editstudentName)) {

      $('#edit-student-name').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidStudentNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidStudentName')); 
      customToastr(pleaseEnterValidStudentNameTranslation, 'error');
      return;
    }

    if ($.isNumeric(editstudentSurname)) {
      $('#edit-student-surname').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidSurnameNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidSurnameName')); 
      customToastr(pleaseEnterValidSurnameNameTranslation, 'error');
      return;
    }

    if (this.formValidator.validateIsData(editstudentStudentEmail) && !this.formValidator.validateIsEmail(editstudentStudentEmail)) {
      $('#edit-student-email').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidStudentEmailTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidStudentEmail')); 
      customToastr(pleaseEnterValidStudentEmailTranslation, 'error');
      return;
    }

    if (this.formValidator.validateIsData(editStudentFatherEmail) && !this.formValidator.validateIsEmail(editStudentFatherEmail)) {
        $('#edit-father-email').addClass('validateErrorforAddStudent');
        isStudentDetailsValid = false;
        const pleaseEnterValidFatherEmailTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherEmail'));
        customToastr(pleaseEnterValidFatherEmailTranslation, 'error');
        return;
    }

    if (this.formValidator.validateIsData(editStudentMotherEmail) && !this.formValidator.validateIsEmail(editStudentMotherEmail)) {
        $('#edit-mother-email').addClass('validateErrorforAddStudent');
        isStudentDetailsValid = false;
        const pleaseEnterValidMotherEmailTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherEmail'));
        customToastr(pleaseEnterValidMotherEmailTranslation, 'error');
        return;
    }

    if (!this.formValidator.validateIsData(editStudentAdmissionnum)) {
      $('#edit-student-admissionnum').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidAdmissionNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidAdmissionNumber')); 
      customToastr(pleaseEnterValidAdmissionNumberTranslation, 'error');
      return;
    }

    if (this.editStudentFormData.student.penNumber) {
      const penNumberLength = this.editStudentFormData.student.penNumber.length;
      if (penNumberLength < 11 || penNumberLength > 12) {
        const pleaseEnterAValidPenNumberWith11Or12DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidPenNumberWith11Or12Digits')); 
        customToastr(pleaseEnterAValidPenNumberWith11Or12DigitsTranslation, 'error');
        return ;
      }
    }

    if (this.formValidator.validateIsData(editstudentStudentAadharNumber) && !(/^[0-9]{12}$/.test(editstudentStudentAadharNumber))) {
      $('#edit-student-aadharNumber').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidAadharNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidAadharNumber')); 
      customToastr(pleaseEnterValidAadharNumberTranslation, 'error');
      return;
    }

    if (!sectionId || sectionId === '0' || sectionId === '') {
      $('#edit-student-section').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidAdmissionNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidAdmissionNumber')); 
      customToastr(pleaseEnterValidAdmissionNumberTranslation, 'error');
      return;
    }

    if (editstudentStudentRollNumber && !$.isNumeric(editstudentStudentRollNumber)) {
      $('#edit-student-surname').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidRollNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidRollNumber')); 
      customToastr(pleaseEnterValidRollNumberTranslation, 'error');
      return;
    }

    // student contact number
    if (this.editSelectedStudentContact) {
      this.validateMobileNumber(this.studentContactNumberInputRef.nativeElement,'student')
      if(this.invalidStudentContactNumber) {
        isStudentDetailsValid = false;
        $('edit-fees-student-number').addClass('validateErrorforAddStudent');
        const pleaseProvideValidStudentSContactNumberTranslation = await firstValueFrom(this.translate.get('pleaseProvideValidStudentSContactNumber')); 
        customToastr(pleaseProvideValidStudentSContactNumberTranslation, 'error');
        return;
      }
    }

    if (!this.formValidator.validateIsData(editstudentFatherName) || $.isNumeric(editstudentFatherName)) {
      $('#edit-student-fathername').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidFatherNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherName')); 
      customToastr(pleaseEnterValidFatherNameTranslation, 'error');
      return;
    }

    // father contact number
    this.validateMobileNumber(this.fatherContactNumberInputRef.nativeElement,'father');
    if (!this.editSelectedFatherContact || this.invalidFatherContactNumber) {
      isStudentDetailsValid = false;
      $('#edit-student-fathernum').addClass('validateErrorforAddStudent');
      const pleaseProvideValidFatherSContactNumberTranslation = await firstValueFrom(this.translate.get('pleaseProvideValidFatherSContactNumber')); 
      customToastr(pleaseProvideValidFatherSContactNumberTranslation, 'error');
      return;
    }

    if (!this.formValidator.validateIsData(editstudentFatherAddress)) {
      $('#edit-student-fatheraddress').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidFatherAddressTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherAddress')); 
      customToastr(pleaseEnterValidFatherAddressTranslation, 'error');
      return;
    }

    if (this.formValidator.validateIsData(editstudentMotherName) && $.isNumeric(editstudentMotherName)) {
      $('#edit-student-mothername').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidMotherNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherName')); 
      customToastr(pleaseEnterValidMotherNameTranslation, 'error');
      return;
    } 

    // mother contact number
    if (this.editSelectedMotherContact){
      this.validateMobileNumber(this.motherContactNumberInputRef.nativeElement,'mother');
      if(this.invalidMotherContactNumber) {
        isStudentDetailsValid = false;
        $('#edit-student-mothernum').addClass('validateErrorforAddStudent');
        const pleaseEnterAValidStudentMotherSMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidStudentMotherSMobileNumber')); 
        customToastr(pleaseEnterAValidStudentMotherSMobileNumberTranslation, 'error');
        return;
      }
    }

    if (this.formValidator.validateIsData(editstudentGuardianName) && $.isNumeric(editstudentGuardianName)) {
      $('#edit-student-guardianname').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
      const pleaseEnterValidGuardianNameTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidGuardianName')); 
      customToastr(pleaseEnterValidGuardianNameTranslation, 'error');
      return;
    }

    if (this.editSelectedGuardianContact){
      this.validateMobileNumber(this.guardianMobileNumberInputRef.nativeElement,'guardian');
      if(this.invalidGuardianContactNumber) {
        isStudentDetailsValid = false;
        $('#edit-fees-student-guardian-mobile-number').addClass('validateErrorforAddStudent');
        const pleaseEnterAValidStudentGuardianMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidStudentGuardianMobileNumber')); 
        customToastr(pleaseEnterAValidStudentGuardianMobileNumberTranslation, 'error');
        return;
      }
    }

    if (editstudentStudentDOB) {
      const selectedDate = moment(editstudentStudentDOB, ['YYYY-MM-DD', 'DD/MM/YYYY']);
      const currentDate = moment();
      const minimumAge = 2;
      if (!selectedDate.isValid()) {
        const pleaseSelectValidDateOfBirthTranslation = await firstValueFrom(this.translate.get('pleaseSelectValidDateOfBirth')); 
        customToastr(pleaseSelectValidDateOfBirthTranslation, 'error');
        $('#edit-student-dob').addClass('validateErrorforAddStudent');
        isStudentDetailsValid = false;
        return false;
      }
      const age = currentDate.diff(selectedDate, 'years');
      if (age < minimumAge) {
        const studentShouldBeAtLeast2YearsOldTranslation = await firstValueFrom(this.translate.get('studentShouldBeAtLeast2YearsOld')); 
        customToastr(studentShouldBeAtLeast2YearsOldTranslation, 'error');
        $('#edit-student-dob').addClass('validateErrorforAddStudent');
        isStudentDetailsValid = false;
        return false;
      }
      else {
        $('#edit-student-dob').removeClass('validateErrorforAddStudent');
      }
      isStudentDetailsValid = true;
    } 
    else {      
      const pleaseSelectValidDateOfBirthTranslation = await firstValueFrom(this.translate.get('pleaseSelectValidDateOfBirth')); 
      customToastr(pleaseSelectValidDateOfBirthTranslation, 'error');
      $('#edit-student-dob').addClass('validateErrorforAddStudent');
      isStudentDetailsValid = false;
    }

    if (this.editStudentFormData.student.fatherPinCode && this.editStudentFormData.student.fatherPinCode.length < 6) {
      const pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (this.editStudentFormData.student.motherPinCode && this.editStudentFormData.student.motherPinCode.length < 6) {
      const pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (this.editStudentFormData.student.guardianPinCode && this.editStudentFormData.student.guardianPinCode.length < 6) {
      const pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidGuardianPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (this.selectedStopId && this.selectedStopId !== "null") {
      if (!this.selectedBusId) {
        const pleaseSelectValidBusTranslation = await firstValueFrom(this.translate.get('pleaseSelectValidBus')); 
        customToastr(pleaseSelectValidBusTranslation, 'error');
        return ;
      }
      const isAnyTermSelected = this.studentSelectedTerms.some(term => term.isSelectedTerm);
      if (!isAnyTermSelected) {
        const pleaseSelectAtLeastOneTermTranslation = await firstValueFrom(this.translate.get('pleaseSelectAtLeastOneTerm')); 
        customToastr(pleaseSelectAtLeastOneTermTranslation, 'error');
        return ;
      }
    }

    if (this.selectedStopId === "null") {
      this.selectedStopId = null;
    }

    let busId = $('#edit-student-bus-selection').val();
    let stopId = $('#edit-student-bus-stop').val();

    if (!isStudentDetailsValid) {
      const pleaseFixErrorFieldsAndProceedTranslation = await firstValueFrom(this.translate.get('pleaseFixErrorFieldsAndProceed')); 
      customToastr(pleaseFixErrorFieldsAndProceedTranslation, 'error');
    }
    else {
      this.admissionObj = {
        studentId: this.editStudentFormData.student.studentId,
        studentName: editstudentName ? editstudentName.trim() : "",
        rollNumber: editstudentStudentRollNumber,
        classId: sectionId,
        parentName: editstudentFatherName ? editstudentFatherName.trim() : "",
        countryCode: this.editStudentFormData.student.countryCode,
        motherCountryCode: this.editStudentFormData.student.motherCountryCode,
        studentCountryCode:this.editStudentFormData.student.studentCountryCode,
        guardianCountryCode:this.editStudentFormData.student.guardianCountryCode,
        studentEmail: this.formValidator.validateIsData(editstudentStudentEmail) ? editstudentStudentEmail.trim() : null,
        emailId: this.formValidator.validateIsData(editStudentFatherEmail) ? editStudentFatherEmail.trim() : null,
        motherEmail: this.formValidator.validateIsData(editStudentMotherEmail) ? editStudentMotherEmail.trim() : null,
        dateOfBirth: editstudentStudentDOB,
        mobileNumber: this.editSelectedFatherContact ? this.editSelectedFatherContact.trim() : "",
        address: editstudentFatherAddress ? editstudentFatherAddress.trim() : "",
        surname: editstudentSurname ? editstudentSurname.trim() : null,
        // reason: this.formValidator.validateIsData(reasonForDeactiveStudent) ? reasonForDeactiveStudent : null,
        studentPhone: this.editSelectedStudentContact ?
          this.editSelectedStudentContact.trim() : null,
        fatherOccupation: editstudentFatherOccupation === '0' ? null : editstudentFatherOccupation,
        fatherQualification: this.formValidator.validateIsData(editstudentFatherQualifiation) ? editstudentFatherQualifiation.trim() : null,
        motherName: editstudentMotherName ? editstudentMotherName.trim() : null,
        motherPhone: this.editSelectedMotherContact ? this.editSelectedMotherContact.trim() : null,
        motherOccupation: editstudentMotherOccupation === '0' ? null : editstudentMotherOccupation,
        motherQualification: this.formValidator.validateIsData(editstudentMotherQualifiation) ? editstudentMotherQualifiation.trim() : null,
        motherAddress: this.formValidator.validateIsData(editstudentMotherAddress) ? editstudentMotherAddress.trim() : null,
        guardianName: editstudentGuardianName ? editstudentGuardianName.trim() : null,
        guardianPhone: this.editSelectedGuardianContact ? this.editSelectedGuardianContact.trim() : null,
        guardianOccupation: editstudentGuardianOccupation === '0' ? null : editstudentGuardianOccupation,
        guardianQualification: this.formValidator.validateIsData(editstudentGuardianQualifiation) ? editstudentGuardianQualifiation.trim() : null,
        guardianAddress: this.formValidator.validateIsData(editstudentGuardianAddress) ? editstudentGuardianAddress.trim() : null,
        registrationId: editStudentAdmissionnum.trim(),
        gender: studentGender,
        isAppUser: studentBluewingsAppStatus,
        isBlocked: studentAccountStatus ? studentAccountStatus : 0,
        deactivationReasonId,
        busId: this.selectedBusId,
        stopId: this.selectedStopId,
        busTermStatuses: this.studentSelectedTerms,
        isClassChanged: false,
        aadharNumber: editstudentStudentAadharNumber ? editstudentStudentAadharNumber.trim() : "",
        houseName,
        penNumber: this.editStudentFormData.student.penNumber,
        fatherPinCode: this.editStudentFormData.student.fatherPinCode,
        motherAnnualIncome: this.editStudentFormData.student.motherAnnualIncome,
        fatherAnnualIncome: this.editStudentFormData.student.fatherAnnualIncome,
        isMinority: this.editStudentFormData.student.isMinority,
        isSpeciallyAbled: this.editStudentFormData.student.isSpeciallyAbled,
        isEWSCategory: this.editStudentFormData.student.isEWSCategory,
        isSingleGirlChild: this.editStudentFormData.student.isSingleGirlChild,
        caste: this.editStudentFormData.student.cast,
        motherPinCode: this.editStudentFormData.student.motherPinCode,
        guardianPinCode: this.editStudentFormData.student.guardianPinCode,
        guardianAnnualIncome: this.editStudentFormData.student.guardianAnnualIncome,
        oldClassId : this.editStudentFormData.student.initialClassId || ''
      };
      if (this.editStudentFormData.student.classId !== this.editStudentFormData.student.initialClassId) {
        this.loaderEditStudent = true;
        this.groupservice.studentClassChangeValidation(this.editStudentFormData.student.classId,this.editStudentFormData.student.initialClassId,
          this.editStudentFormData.student.studentId, this.getAuthToken)
          .subscribe(
            (data: any) => {
              if (data.allowUpdate === 'NO') {
                this.editStudentLoadStatus = false;
                this.updateStudentClassChangeError = data;
                this.showClassChangeWarning = true;
              } 
              else {
                this.showClassChangeWarning = false;
                this.admissionObj.oldClassId = this.editStudentFormData.student.initialClassId || '';
                this.admissionObj.isClassChanged = true;
                this.updateStudentDetail();
              }
            },
            async error => {
              this.loaderEditStudent = false;
              const studentDetailsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('studentDetailsNotUpdatedPleaseTryAgain')); 
              customToastr(studentDetailsNotUpdatedPleaseTryAgainTranslation, 'error');
            }
          );
        this.editStudentLoadStatus = false;
      } else {
        this.updateStudentDetail();
      }
    }
  }

  updateStudentDetail() {
    this.loader = true;
    this.groupservice.updateStudentDetails(this.admissionObj, this.getAuthToken)
      .subscribe(
        async (data: any) => {
          this.loader = false;
          if (data.status === true) {
            const studentDetailsUpdatedTranslation = await firstValueFrom(this.translate.get('studentDetailsUpdated')); 
            customToastr(studentDetailsUpdatedTranslation, 'success');
            $('#edit-student-popup-close').trigger('click');
            $('#notificationpopupclose').trigger('click');
            $('#confirm-student-details-updated').trigger('click');

          } else {
            if (data.message) {
              customToastr(data.message, 'error');
            } else {
              const studentDetailsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('studentDetailsNotUpdatedPleaseTryAgain')); 
              customToastr(studentDetailsNotUpdatedPleaseTryAgainTranslation, 'error');
            }
          }
        },
        async error => {
          this.loader = false;
          const studentDetailsNotUpdatedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('studentDetailsNotUpdatedPleaseTryAgain')); 
          customToastr(studentDetailsNotUpdatedPleaseTryAgainTranslation, 'error');
          $('#notificationpopupclose').trigger('click');
        }
      );
  }

  formatDOBForDisplay(dob: string): string {
    return moment(dob).format('YYYY-MM-DD');
  }

  // Mobile number validation function
  validateMobileNumber(value, fieldType: string): void {
    let isValid = false;
    const fullNumber = $(value).intlTelInput('getNumber');
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (phoneNumber) {
      isValid = phoneNumber.isValid();
    } 
    switch (fieldType) {
      case 'student':
        this.invalidStudentContactNumber = !isValid;
        break;
      case 'father':
        this.invalidFatherContactNumber = !isValid;
        break;
      case 'mother':
        this.invalidMotherContactNumber = !isValid;
        break;
      case 'guardian':
        this.invalidGuardianContactNumber = !isValid;
        break;
    }
  }

  /////////// New fields file uploads ///////
  startUploadingEditStudentTcOrCopy(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.tcOrBirthCertificateFileType = file.type;
      if (this.validateImage('#edit-fees-student-tc-or-birth-copy', '#edit-fees-student-tc-or-birth-progressbar', '#edit-fees-student-tc-or-birth-image-ele')) {
        document.getElementById('edit-fees-student-tc-or-birth-copy-button')?.classList.add('hide');
        this.showProgressForTcOrBirth = true;
        const authToken = localStorage.getItem('usertoken');
        const imageId = 'edit-fees-student-tc-or-birth-copy';
        const studentId = this.studentId.toString();
        const ImageUploadData = new FormData();
        ImageUploadData.append('tcOrBirthCertificate', (document.getElementById(imageId) as HTMLInputElement).files![0]);
        this.editStudentPopupService.uploadEditStudentImageApi(studentId, authToken, ImageUploadData)
          .subscribe(
            async (data: any) => {
              this.showProgressForTcOrBirth = false;
              if (data.body && data.body.processedImageUrl[0]) {
                this.editStudentFormData.student.tcOrBirthCertificate = data.body.processedImageUrl[0]
              }
              document.getElementById('edit-fees-student-tc-or-birth-copy-button')?.classList.remove('hide');
              const studentTcBirthCopyUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentTcBirthCopyUpdatedSuccessfully')); 
              customToastr(studentTcBirthCopyUpdatedSuccessfullyTranslation, 'success');
              this.profileImageSelected = false;
            },
            async error => {
              this.showProgressForTcOrBirth = false;
              const tcBirthCertificateCopyNotUpdatedTranslation = await firstValueFrom(this.translate.get('tcBirthCertificateCopyNotUpdated')); 
              customToastr(tcBirthCertificateCopyNotUpdatedTranslation, 'error');
              this.profileImageSelected = false;
              const button = document.getElementById('edit-fees-student-tc-or-birth-copy-button');
              const imageElement = document.getElementById('edit-fees-student-tc-or-birth-image-ele') as HTMLImageElement;
              const inputElement = document.getElementById('edit-fees-student-tc-or-birth-copy') as HTMLInputElement;
              if (this.editStudentFormData.student.tcOrBirthCertificate) {
                button!.textContent = 'Change';
                inputElement.value = '';
                imageElement.src = this.editStudentFormData.student.tcOrBirthCertificate;
                imageElement.classList.remove('hide');
              } else {
                button!.textContent = 'Upload';
                inputElement.value = '';
                imageElement.src = '';
                imageElement.classList.add('hide');
              }
            }
          );
      }
    }
  }

  openEditStudentTcORCopyUpload() {
    document.getElementById('edit-fees-student-tc-or-birth-copy')?.click();
  }


  openEditStudentSpeciallyAbledCopyUpload() {
    document.getElementById('edit-fees-student-specially-abled-copy')?.click();
  }

  openEditStudentEWSCopyUpload() {
    document.getElementById('edit-fees-student-EWS-copy')?.click();
  }

  openEditStudentSingleGirlCopyUpload() {
    document.getElementById('edit-fees-student-single-girl-copy')?.click();
  }


  openEditStudentCasteCertificateCopyUpload() {
    document.getElementById('edit-fees-student-caste-copy')?.click();
  }

  startUploadingEditStudentSpeciallyAbledCopy(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.speciallyAbledFileType = file.type;
      if (this.validateImage('#edit-fees-student-specially-abled-copy', '#edit-fees-student-specially-abled-progressbar', '#edit-fees-student-specially-abled-image-ele')) {
        document.getElementById('edit-fees-student-specially-abled-copy-button')?.classList.add('hide');
        this.showProgressForSpeciallyAbled = true;
        const authToken = localStorage.getItem('usertoken');
        const imageId = 'edit-fees-student-specially-abled-copy';
        const studentId = this.studentId.toString();
        const ImageUploadData = new FormData();
        ImageUploadData.append('speciallyAbled', (document.getElementById(imageId) as HTMLInputElement).files![0]);
        this.editStudentPopupService.uploadEditStudentImageApi(studentId, authToken, ImageUploadData)
          .subscribe(
            async (data: any) => {
              if (data.body && data.body.processedImageUrl[0]) {
                this.editStudentFormData.student.speciallyAbledCertificate = data.body.processedImageUrl[0]
              }
              this.showProgressForSpeciallyAbled = false;
              document.getElementById('edit-fees-student-specially-abled-copy-button')?.classList.remove('hide');
              const studentSpeciallyAbledCopyUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentSpeciallyAbledCopyUpdatedSuccessfully')); 
              customToastr(studentSpeciallyAbledCopyUpdatedSuccessfullyTranslation, 'success');
              this.profileImageSelected = false;
            },
            async error => {
              this.showProgressForSpeciallyAbled = false;
              const speciallyAbledCertificateCopyNotUpdatedTranslation = await firstValueFrom(this.translate.get('speciallyAbledCertificateCopyNotUpdated')); 
              customToastr(speciallyAbledCertificateCopyNotUpdatedTranslation, 'error');
              this.profileImageSelected = false;
              const button = document.getElementById('edit-fees-student-specially-abled-copy-button');
              const imageElement = document.getElementById('edit-fees-student-specially-abled-image-ele') as HTMLImageElement;
              const inputElement = document.getElementById('edit-fees-student-specially-abled-copy') as HTMLInputElement;
              if (this.editStudentFormData.student.speciallyAbledCertificate) {
                button!.textContent = 'Change';
                inputElement.value = '';
                imageElement.src = this.editStudentFormData.student.speciallyAbledCertificate;
                imageElement.classList.remove('hide');
              } else {
                button!.textContent = 'Upload';
                inputElement.value = '';
                imageElement.src = '';
                imageElement.classList.add('hide');
              }
            }
          );
      }
    }

  }

  startUploadingEditStudentEWSCopy(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.ewsCertificateFileType = file.type;
      if (this.validateImage('#edit-fees-student-EWS-copy', '#edit-fees-student-EWS-progressbar', '#edit-fees-student-EWS-image-ele')) {
        document.getElementById('edit-fees-student-EWS-copy-button')?.classList.add('hide');
        this.showProgressForEWS = true;
        const authToken = localStorage.getItem('usertoken');
        const imageId = 'edit-fees-student-EWS-copy';
        const studentId = this.studentId.toString();
        const ImageUploadData = new FormData();
        ImageUploadData.append('ewsCertificate', (document.getElementById(imageId) as HTMLInputElement).files![0]);
        this.editStudentPopupService.uploadEditStudentImageApi(studentId, authToken, ImageUploadData)
          .subscribe(
            async (data: any) => {
              this.showProgressForEWS = false;
              if (data.body && data.body.processedImageUrl[0]) {
                this.editStudentFormData.student.ewsCertificate = data.body.processedImageUrl[0]
              }
              document.getElementById('edit-fees-student-EWS-copy-button')?.classList.remove('hide');
              const studentEwsCopyUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentEwsCopyUpdatedSuccessfully')); 
              customToastr(studentEwsCopyUpdatedSuccessfullyTranslation, 'success');
              this.profileImageSelected = false;
            },
            async error => {
              this.showProgressForEWS = false;
              const speciallyewsCopyNotUpdatedTranslation = await firstValueFrom(this.translate.get('speciallyewsCopyNotUpdated')); 
              customToastr(speciallyewsCopyNotUpdatedTranslation, 'error');
              this.profileImageSelected = false;
              const button = document.getElementById('edit-fees-student-EWS-copy-button');
              const imageElement = document.getElementById('edit-fees-student-EWS-image-ele') as HTMLImageElement;
              const inputElement = document.getElementById('edit-fees-student-EWS-copy') as HTMLInputElement;
              if (this.editStudentFormData.student.ewsCertificate) {
                button!.textContent = 'Change';
                inputElement.value = '';
                imageElement.src = this.editStudentFormData.student.ewsCertificate;
                imageElement.classList.remove('hide');
              } else {
                button!.textContent = 'Upload';
                inputElement.value = '';
                imageElement.src = '';
                imageElement.classList.add('hide');
              }
            }
          );
      }
    }

  }

  startUploadingEditStudentSingleGirlChildCopy(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.singleGirlChildCertificateFileType = file.type;
      if (this.validateImage('#edit-fees-student-single-girl-copy', '#edit-fees-student-single-girl-progressbar', '#edit-fees-student-single-girl-image-ele')) {
        document.getElementById('edit-fees-student-single-girl-copy-button')?.classList.add('hide');
        this.showProgressForSingleGirlChild = true;
        const authToken = localStorage.getItem('usertoken');
        const imageId = 'edit-fees-student-single-girl-copy';
        const studentId = this.studentId.toString();
        const ImageUploadData = new FormData();
        ImageUploadData.append('singleGirlChildCertificate', (document.getElementById(imageId) as HTMLInputElement).files![0]);
        this.editStudentPopupService.uploadEditStudentImageApi(studentId, authToken, ImageUploadData)
          .subscribe(
            async (data: any) => {
              this.showProgressForSingleGirlChild = false;
              if (data.body && data.body.processedImageUrl[0]) {
                this.editStudentFormData.student.singleGirlChildCertificate = data.body.processedImageUrl[0]
              }
              document.getElementById('edit-fees-student-single-girl-copy-button')?.classList.remove('hide');
              const studentSingleGirlChildCopyUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentSingleGirlChildCopyUpdatedSuccessfully')); 
              customToastr(studentSingleGirlChildCopyUpdatedSuccessfullyTranslation, 'success');
              this.profileImageSelected = false;
            },
            async error => {
              this.showProgressForSingleGirlChild = false;
              const singleGirlChildCopyNotUpdatedTranslation = await firstValueFrom(this.translate.get('singleGirlChildCopyNotUpdated')); 
              customToastr(singleGirlChildCopyNotUpdatedTranslation, 'error');
              this.profileImageSelected = false;
              const button = document.getElementById('edit-fees-student-single-girl-copy-button');
              const imageElement = document.getElementById('edit-fees-student-single-girl-image-ele') as HTMLImageElement;
              const inputElement = document.getElementById('edit-fees-student-single-girl-copy') as HTMLInputElement;
              if (this.editStudentFormData.student.singleGirlChildCertificate) {
                button!.textContent = 'Change';
                inputElement.value = '';
                imageElement.src = this.editStudentFormData.student.singleGirlChildCertificate;
                imageElement.classList.remove('hide');
              } else {
                button!.textContent = 'Upload';
                inputElement.value = '';
                imageElement.src = '';
                imageElement.classList.add('hide');
              }
            }
          );
      }
    }

  }

  startUploadingEditStudentCasteCopy(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.casteCertificateFileType = file.type;
      if (this.validateImage('#edit-fees-student-caste-copy', '#edit-fees-student-caste-progressbar', '#edit-fees-student-caste-image-ele')) {
        document.getElementById('edit-fees-student-caste-copy-button')?.classList.add('hide');
        this.showProgressForCaste = true;
        const authToken = localStorage.getItem('usertoken');
        const imageId = 'edit-fees-student-caste-copy';
        const studentId = this.studentId.toString();
        const ImageUploadData = new FormData();
        ImageUploadData.append('casteCertificate', (document.getElementById(imageId) as HTMLInputElement).files![0]);
        this.editStudentPopupService.uploadEditStudentImageApi(studentId, authToken, ImageUploadData)
          .subscribe(
            async (data: any) => {
              this.showProgressForCaste = false;
              if (data.body && data.body.processedImageUrl[0]) {
                this.editStudentFormData.student.casteCertificate = data.body.processedImageUrl[0]
              }
              document.getElementById('edit-fees-student-caste-copy-button')?.classList.remove('hide');
              const studentCasteCopyUpdatedSuccessfullyTranslation = await firstValueFrom(this.translate.get('studentCasteCopyUpdatedSuccessfully')); 
              customToastr(studentCasteCopyUpdatedSuccessfullyTranslation, 'success');
              this.profileImageSelected = false;
            },
            async error => {
              this.showProgressForCaste = false;
              const ewsCopyNotUpdatedTranslation = await firstValueFrom(this.translate.get('ewsCopyNotUpdated')); 
              customToastr(ewsCopyNotUpdatedTranslation, 'error');
              this.profileImageSelected = false;
              const button = document.getElementById('edit-fees-student-caste-copy-button');
              const imageElement = document.getElementById('edit-fees-student-caste-image-ele') as HTMLImageElement;
              const inputElement = document.getElementById('edit-fees-student-caste-copy') as HTMLInputElement;
              if (this.editStudentFormData.student.casteCertificate) {
                button!.textContent = 'Change';
                inputElement.value = '';
                imageElement.src = this.editStudentFormData.student.casteCertificate;
                imageElement.classList.remove('hide');
              } else {
                button!.textContent = 'Upload';
                inputElement.value = '';
                imageElement.src = '';
                imageElement.classList.add('hide');
              }
            }
          );
      }
    }
  }

  onMinorityChange(event: any) {
    this.editStudentFormData.student.isMinority = event.target.checked === true ? 1 : 0
  }
  onIsSpeciallyAbledChange(event: any) {
    this.editStudentFormData.student.isSpeciallyAbled = event.target.checked === true ? 1 : 0
  }

  onIsEWSCategoryChange(event: any) {
    this.editStudentFormData.student.isEWSCategory = event.target.checked === true ? 1 : 0
  }
  onIsSingleGirlChildChange(event: any) {
    this.editStudentFormData.student.isSingleGirlChild = event.target.checked === true ? 1 : 0
  }
  onCasteChange() {
    this.editStudentFormData.student.isEWSCategory = (this.editStudentFormData.student.cast !== 'General') ? 0 : this.editStudentFormData.student.isEWSCategory;

  }
  onGenderChange() {
    this.editStudentFormData.student.isSingleGirlChild = (this.editStudentFormData.student.gender === 1) ? 0 : this.editStudentFormData.student.isSingleGirlChild;
  }

}